export const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null
  && typeof value === 'object'
  && !Array.isArray(value);

export const normalizeNestedRemainingSoftwarePercentage = (
  parameters: unknown,
) => {
  if (
    !isRecord(parameters)
    || Reflect.has(parameters, 'remainingSoftwarePercentage')
  ) {
    return parameters;
  }

  const { fields } = parameters;

  if (!isRecord(fields) || !Reflect.has(fields, 'remainingSoftwarePercentage')) {
    return parameters;
  }

  const { remainingSoftwarePercentage, ...profileFields } = fields;

  return {
    ...parameters,
    fields: profileFields,
    remainingSoftwarePercentage,
  };
};
